var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect } from "react";
import classNames from "classnames";
import usePagedSortedTable, { TotalPageMappers, } from "../../Hooks/usePagedSortedTable";
import useCheckboxes from "../../Hooks/useCheckboxes";
import FAIcon from "../../UI/FAIcon/FAIcon";
import DuplicateReviewModal from "./DuplicateReviewModal";
import TextField from "../../Form/TextField";
import { InlineFormFormat } from "../../UI/FormFormat/FormFormat";
import DuplicatePersonService from "../../../Services/DuplicatePerson.service";
import DuplicateIgnoreModal from "./DuplicateIgnoreModal";
import DuplicateUnignoreModal from "./DuplicateUnignoreModal";
import DateService from "../../../Services/Shared/Date.service";
import PersonLiteDomainService from "../../../Domain/PersonLite/PersonLite.service";
const PAGE_SIZE = 25;
const DuplicatePersonTable = ({ search, actions, noTableCheckboxes, noReviewAndMergeAllowed, counterState, refreshTable, setRefreshTable, }) => {
    const { getCheckbox, checkedItems, unCheckEverything, unCheckStuff } = useCheckboxes({
        externallyCheckedItems: [],
        equalsFunc: (a, b) => a.id === b.id,
    });
    const [reviewModalIsOpen, setReviewModalOpen] = React.useState(false);
    const [bulkIgnoreModalIsOpen, setBulkIgnoreModalOpen] = React.useState(false);
    const [bulkUnignoreModalIsOpen, setBulkUnignoreModalOpen] = React.useState(false);
    const [searchArgs, setSearchArgs] = React.useState({});
    // @ts-expect-error - TS2345 - Argument of type '{}' is not assignable to parameter of type 'DuplicatePerson | (() => DuplicatePerson)'.
    const [modalData, setModalData] = React.useState({});
    const handleReview = (data) => {
        setModalData(data);
        setReviewModalOpen(true);
    };
    const reviewHeaderTitle = noReviewAndMergeAllowed
        ? "Review"
        : "Review and Merge";
    const checkboxesValidation = noTableCheckboxes
        ? undefined
        : {
            useCheckboxesMakeCheckbox: getCheckbox,
            // @ts-expect-error - TS7006 - Parameter 'data' implicitly has an 'any' type. | TS7006 - Parameter 'index' implicitly has an 'any' type.
            getCheckedItem: (data, index) => data.data[index],
        };
    const { table, dataState, refresh } = usePagedSortedTable({
        searchArgs,
        addCheckboxes: checkboxesValidation,
        getNumPages: (result) => TotalPageMappers.EngagePagedResult(result, PAGE_SIZE),
        getData: (sort, pageNumber, sArgs) => {
            return DuplicatePersonService.search(Object.assign(Object.assign(Object.assign({}, sArgs), search), { duplicatedDueToMerge: false, personDeleted: false }), {
                max: PAGE_SIZE,
                offset: pageNumber * PAGE_SIZE,
                sort: sort === null || sort === void 0 ? void 0 : sort.sort,
                order: (sort === null || sort === void 0 ? void 0 : sort.order) === "asc" ? "ascnullsfirst" : "descnullslast",
            });
        },
        columns: [
            {
                title: reviewHeaderTitle,
                align: "center",
                size: 0.75,
            },
            { title: "Name", sortId: "DUPLICATE_PERSON_PERSONA_FNAME" },
            {
                title: "Birthdate",
                sortId: "DUPLICATE_PERSON_PERSONA_BDAY",
                size: 0.72,
            },
            {
                title: "Institution ID",
                sortId: "DUPLICATE_PERSON_PERSONA_INST_ID",
                size: 0.9,
            },
            {
                title: "Email Address",
                sortId: "DUPLICATE_PERSON_PERSONA_SECONDARY_EMAIL",
                size: 1.5,
            },
            {
                title: "Person Types",
                size: 0.9,
            },
            { title: "", size: 0.5 },
            { title: "Duplicate Name", sortId: "DUPLICATE_PERSON_PERSONB_FNAME" },
            {
                title: "Duplicate Birthdate",
                sortId: "DUPLICATE_PERSON_PERSONB_BDAY",
                size: 0.72,
            },
            {
                title: "Duplicate Institution ID",
                sortId: "DUPLICATE_PERSON_PERSONB_INST_ID",
                size: 0.9,
            },
            {
                title: "Duplicate Email Address",
                sortId: "DUPLICATE_PERSON_PERSONB_SECONDARY_EMAIL",
                size: 1.5,
            },
            {
                title: "Duplicate Person Types",
                size: 0.9,
            },
        ],
        // We are manually switching on frontend the order of person A and B based on whether person A is mergeable
        // This change mainly affects the Auto Mergeable tab table, making it more predictable and easier to read
        rows: ({ data }) => data.map((duplicate, index) => {
            var _a, _b;
            return [
                _jsx("button", { className: "btn btn-link", children: _jsx(FAIcon, { icon: "object-ungroup", onClick: () => handleReview(duplicate) }) }, duplicate.id),
                duplicate.personA_IsMergeable
                    ? duplicate.personA.fullName
                    : duplicate.personB.fullName,
                _jsx("div", { style: { wordBreak: "break-all" }, children: duplicate.personA_IsMergeable
                        ? duplicate.personA.birthDate &&
                            DateService.display(PersonLiteDomainService.getBirthDate(duplicate.personA))
                        : duplicate.personB.birthDate &&
                            DateService.display(PersonLiteDomainService.getBirthDate(duplicate.personB)) }, index),
                _jsx("div", { style: { wordBreak: "break-all" }, children: duplicate.personA_IsMergeable
                        ? duplicate.personA.studentId
                        : duplicate.personB.studentId }, index),
                _jsx("div", { style: { wordBreak: "break-all" }, children: duplicate.personA_IsMergeable
                        ? duplicate.personA.secondaryEmailAddress
                        : duplicate.personB.secondaryEmailAddress }, index),
                _jsx("div", { style: { wordBreak: "break-all" }, children: duplicate.personA_IsMergeable
                        ? (_a = duplicate.personA.personTypes) === null || _a === void 0 ? void 0 : _a.map((pt) => pt.name).join(", ")
                        : (_b = duplicate.personB.personTypes) === null || _b === void 0 ? void 0 : _b.map((pt) => pt.name).join(", ") }, index),
                _jsx("div", { children: "\u2014" }, index),
                duplicate.personA_IsMergeable
                    ? duplicate.personB.fullName
                    : duplicate.personA.fullName,
                _jsx("div", { style: { wordBreak: "break-all" }, children: duplicate.personA_IsMergeable
                        ? duplicate.personB.birthDate &&
                            DateService.display(PersonLiteDomainService.getBirthDate(duplicate.personB))
                        : duplicate.personA.birthDate &&
                            DateService.display(PersonLiteDomainService.getBirthDate(duplicate.personA)) }, index),
                _jsx("div", { style: { wordBreak: "break-all" }, children: duplicate.personA_IsMergeable
                        ? duplicate.personB.studentId
                        : duplicate.personA.studentId }, index),
                _jsx("div", { style: { wordBreak: "break-all" }, children: duplicate.personA_IsMergeable
                        ? duplicate.personB.secondaryEmailAddress
                        : duplicate.personA.secondaryEmailAddress }, index),
                _jsx("div", { style: { wordBreak: "break-all" }, children: duplicate.personA_IsMergeable
                        ? // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
                            duplicate.personB.personTypes.map((pt) => pt.name).join(", ")
                        : // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
                            duplicate.personA.personTypes.map((pt) => pt.name).join(", ") }, index),
            ];
        }),
        noDataComponent: "No duplicates were found",
    });
    React.useEffect(() => {
        var _a;
        counterState((_a = dataState.data) === null || _a === void 0 ? void 0 : _a.total);
    }, [dataState, counterState]);
    useEffect(() => {
        if (refreshTable && setRefreshTable) {
            refresh().then(() => {
                setRefreshTable(false);
            });
        }
    }, [refreshTable, setRefreshTable, refresh]);
    const handleModal = (id) => {
        switch (id) {
            case 1: {
                setBulkIgnoreModalOpen(true);
                break;
            }
            case 2: {
                setBulkUnignoreModalOpen(true);
                break;
            }
            default: {
                break;
            }
        }
    };
    return (_jsxs(_Fragment, { children: [_jsxs(InlineFormFormat, { saveButtonContents: "Search", handleSubmit: (formState) => __awaiter(void 0, void 0, void 0, function* () {
                    setSearchArgs({
                        query: formState.query,
                        bothPersonInstitutionPersonId: formState.institutionPersonId,
                        bothPersonSecondaryEmailAddress: formState.secondaryEmailAddress,
                    });
                }), children: [_jsx(TextField, { name: "query", label: "Search Name" }), _jsx(TextField, { name: "institutionPersonId", label: "Institution Person Id" }), _jsx(TextField, { name: "secondaryEmailAddress", label: "Email Address" })] }), actions && (_jsxs("div", { className: "d-flex flex-row items-center mt-3", children: [_jsx(DuplicateIgnoreModal, { duplicates: checkedItems, isOpen: bulkIgnoreModalIsOpen, onModalClosed: () => {
                            setBulkIgnoreModalOpen(false);
                            refresh();
                        }, unCheckEverything: unCheckEverything }, 1), _jsx(DuplicateUnignoreModal, { duplicates: checkedItems, isOpen: bulkUnignoreModalIsOpen, onModalClosed: () => {
                            setBulkUnignoreModalOpen(false);
                            refresh();
                        }, unCheckEverything: unCheckEverything }, 2), actions.length > 1 ? (_jsxs("div", { className: "dropdown", children: [_jsx("button", { className: classNames("btn btn-link dropdown-toggle"), "data-toggle": "dropdown", title: "Open menu", disabled: checkedItems.length === 0, children: "Actions" }), _jsx("div", { className: "dropdown-menu shadow", children: actions === null || actions === void 0 ? void 0 : actions.map((action) => {
                                    return (_jsxs("button", { className: "dropdown-item btn btn-link text-primary", onClick: () => handleModal(action.id), title: action.title, children: [_jsx(FAIcon, { icon: action.icon, fixedWidth: true, addMarginRight: true }), action.name] }, action.id));
                                }) })] })) : (_jsx(_Fragment, { children: _jsxs("button", { className: "btn btn-link", onClick: () => handleModal(actions[0].id), title: actions[0].title, disabled: checkedItems.length === 0, children: [_jsx(FAIcon, { icon: actions[0].icon, fixedWidth: true, addMarginRight: true }), actions[0].name] }, actions[0].id) }))] })), _jsx("div", { className: "py-2", children: table }), reviewModalIsOpen && (_jsx(DuplicateReviewModal, { isOpen: reviewModalIsOpen, onModalClosed: () => {
                    setReviewModalOpen(false);
                    refresh();
                }, duplicate: modalData, unCheckStuff: unCheckStuff, unMountContentWhenClosed: true, noReviewAndMergeAllowed: noReviewAndMergeAllowed, setReviewModalOpen: setReviewModalOpen, refreshTable: refresh }))] }));
};
export default DuplicatePersonTable;
